module.exports = __webpack_public_path__ + "img/border-top.a7770524.svg";